import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { vehicleColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiVehicle } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { VehiclesRepository } from '@Repositories/Stammdaten';

export function FrameListVehicle() {
    const hasPermission = useHasPermission();

    const module = useListApi(VehiclesRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiVehicle>
            layoutSettingsContext={EnumFrontendLayoutSetting.VehiclesTableLayout}
            name="VehicleList"
            columns={vehicleColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenVehiclesCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
